'use client'
import { cn } from '../../utils'

export function CloseBtn(props: { onClose: () => void; className?: string; size?: number }) {
  const { onClose, className, size = 28 } = props
  return (
    <div
      onClick={onClose}
      className={cn('hover:text-primary right-10 top-10 cursor-pointer p-1 outline-none', className)}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 36 36" fill="currentColor">
        <path
          d="M15.5541 18.1747L0 33.5L2.8074 36.3493L18.4037 20.9824L34 36.3493L36.8074 33.5L21.2533 18.1747L36.8074 2.8493L34 0L18.4037 15.3669L2.8074 0L0 2.8493L15.5541 18.1747Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}
